<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid>
        <v-layout justify-center>
          <v-flex xs12 sm12 md6>
            <v-card>
              <v-toolbar flat>
                <v-toolbar-title>パスワード変更</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    id="oldpass"
                    v-model="oldpass"
                    placeholder="現在のパスワードを入力してください"
                    prepend-icon="lock"
                    name="oldpass"
                    label="現在のパスワード"
                    type="password"
                  ></v-text-field>
                  <v-text-field
                    id="newpass"
                    v-model="newpass"
                    placeholder="新しいパスワードを入力してください"
                    prepend-icon="lock"
                    name="newpass"
                    label="新しいパスワード"
                    type="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="update">パスワードを変更する</v-btn>
              </v-card-actions>
              <v-alert :value="alert" type="error" transition="scale-transition">{{msg}}</v-alert>
            </v-card>

            <v-card class="mt-5">
              <v-toolbar flat>
                <v-toolbar-title>デジタルハンコ登録</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <img v-if="hanko" :src="hanko.name" />
                <v-file-input label="ハンコ画像を選択してください" @change="getFileName"></v-file-input>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="update">デジタルハンコ登録する</v-btn>
              </v-card-actions>
              <v-alert :value="alert" type="error" transition="scale-transition">{{msg}}</v-alert>
            </v-card>
          </v-flex>
        </v-layout>

        <v-snackbar v-model="snackbar" color="success" :timeout="2000">
          {{ msg }}
          <v-btn @click="snackbar = false">閉じる</v-btn>
        </v-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Auth from "@/components/Auth";
export default {
  mixins: [Auth],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    source: String,
  },
  data: () => ({
    drawer: false,
    oldpass: "",
    newpass: "",
    hanko: "",
    snackbar: "",
  }),
  methods: {
    getFileName(e) {
      console.log("fileが選択されました。");
      console.log(e);
    },
    update() {
      var self = this;
      this.$axios
        .post(
          this.url + "updatePass.php",
          JSON.stringify({
            oldpass: this.oldpass,
            newpass: this.newpass,
            id: this.$store.getters.auth.id,
          })
        )
        .then(function (res) {
          self.msg = "パスワードを変更しました。";
          console.log(res);
          if (!res.data)
            self.msg =
              "更新に失敗しました、パスワードが間違っている可能性があります。";
          if (self.msg !== "") {
            self.snackbar = true;
          }
        });
    },
  },
};
</script>

<style lang="stylus"></style>
